<template>
  <RouterView />
</template>

<script setup>
import { defineComponent } from 'vue'
import { RouterView } from 'vue-router'

defineComponent({
  name: 'App'
})
</script>

<style>
@import "@/assets/css/tailwind.css";
@import url('https://fonts.googleapis.com/css2?family=Courier+Prime:ital,wght@0,400;0,700;1,400;1,700&display=swap');

#app {
  font-family: "Courier Prime", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 400;
  font-style: normal;
  user-select: none; /* Disable text selection globally */
  -webkit-user-select: none; /* Safari */
}
</style>
